module.exports = __webpack_public_path__ + "static/img/partner_XVI.677327c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_XVI.png
// module id = 0zq7
// module chunks = 9